import { render, staticRenderFns } from "./CallsLink.vue?vue&type=template&id=3dcc2350"
import script from "./CallsLink.vue?vue&type=script&lang=js"
export * from "./CallsLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports